import {PlanningDataUtils} from "./PA.TPM.Core/PlanningDataUtils";
import {PlanService} from "./PA.TPM.Services/PlanService";
import {PlanningService} from "./PA.TPM.Services/PlanningService";
import {PAExport} from "./PA.Export.Core/PAExport";
import {DetailAttributes} from "./PA.Metric.Services/PA.Metrics.IF";
import {MetricParameters, MetricsParameterSet} from "./PA.Metric.Services/PAMetrics";
import {PAFile} from "./PA.File.Core/PAFile";
import {ConsumptionAdjustmentsFactory} from "./PA.Consumption.Core/ConsumptionAdjustmentsFactory";
import {UserSecurityService} from "./PA.Security.Services/UserSecurityService";
import {AuditService} from "./PA.Core/Security/AuditService";
import {AuditLogType} from "./PA.Core/PA.Core.IF.Audit";
import {ConditionCollection} from "./PA.MD.Services/ConditionCollection";
import {ConsumerProductService} from "./PA.MD.Services/ConsumerProductService";
import {PeriodService} from "./PA.MD.Services/PeriodService";
import {ControlPointService} from "./PA.MD.Services/ControlPointService";
import {CustomerHierarchy} from "./PA.MD.Services/CustomerHierarchy";
import {ProductHierarchy} from "./PA.MD.Services/ProductHierarchy";
import {PeriodHierarchy} from "./PA.MD.Services/PeriodHierarchy";
import {PeriodHierarchyService} from "./PA.MD.Services/PeriodHierarchyService";
import {ProductHierarchyService} from "./PA.MD.Services/ProductHierarchyService";
import {FilteredHierarchy} from "./PA.MD.Services/FilteredHierarchy";
import {EntityManager} from "./PA.MD.Core/EntityManager";
import {EntityTypeUtils} from "./PA.MD.Entity/EntityTypeUtils";
import {MDUsageService} from "./PA.MD.Services/MDUsageService";
import {LoaderStatus} from "./PA.Loader.Core/PA.Loader.IF.Aspects";
import {Loader} from "./PA.Loader.Services/Loader";
import {HierarchyService} from "./PA.MD.Hierarchy/HierarchyService";
import {HierarchyProcessingStatus} from "./PA.MD.Core/PA.MD.IF.Hierarchy";
import {HierarchyStructureManager} from "./PA.MD.Hierarchy/HierarchyStructureManager";
import {HierarchyStructureNavigator} from "./PA.MD.Hierarchy/HierarchyStructureNavigator";
import {BusinessPolicyService} from "./PA.MD.BusinessPolicy/BusinessPolicyService";
import {BusinessPolicyProcessingStatus} from "./PA.MD.Core/PA.MD.IF.BusinessPolicy";
import {CubeSourceMetaDataService} from "./PA.HyperRectangle.Services/CubeSourceMetaDataService";
import {CubeSourceUtils} from "./PA.HyperRectangle.Core/CubeSourceUtils";
import {ModelUtils} from "./PA.Model.Services/ModelUtils";
import {ModelingSessionStatus} from "./PA.Model.Services/ModelingSessionServices.IF";
import {ModelingSessionService} from "./PA.Model.Services/ModelingSessionService";
import {SettlementMetricsService} from "./PA.Settlements.Services/SettlementMetricsService";
import {PALockClient} from "./PA.Concurrency.Services/PALockClient";
import {PALockAdminClient} from "./PA.Concurrency.Services/PALockAdminClient";
import {UIClipboardService, UIFrameworkService} from "./PA.UIFramework.Services/UIFrameworkService";
import {DimensionDataService} from "./PA.Reporting.Services/DimensionDataService";
import {PAReportTokenService} from "./PA.Reporting.Services/PATableauTokenService";
import {PATagDataService} from "./PA.Reporting.Services/PATagDataService";
import {ModelingScorecardService} from "./PA.Model.Services/ModelingScorecardService";
import {JobParamManager} from "./PA.Job.Core/JobParamManager";
import {SnapshotService} from "./PA.Snapshot.Services/SnapshotService";

const MdlServices = {

    Services: {
        TPM: {
            PlanningDataUtils: PlanningDataUtils,
            PlanService: PlanService,
            PlanningService: PlanningService,
            SnapshotService:SnapshotService
        },
        Export: {
            Export: PAExport
        },
        Metric: {
            DetailAttributes: DetailAttributes,
            MetricParameters:MetricParameters,
            MetricParameterSet:MetricsParameterSet
        },
        File: {
            File: PAFile
        },
        Consumption: {
            AdjustmentFactory: ConsumptionAdjustmentsFactory
        },
        Security: {
            UserSecurityService: UserSecurityService,
            AuditService: AuditService,
            AuditLogType: AuditLogType
        },
        MD: {
            ConditionCollection: ConditionCollection,
            ConsumerProductService: ConsumerProductService,
            PeriodService: PeriodService,
            ControlPointService: ControlPointService,
            CustomerHierarchy: CustomerHierarchy,
            ProductHierarchy: ProductHierarchy,
            PeriodHierarchy: PeriodHierarchy,
            PeriodHierarchyService: PeriodHierarchyService,
            ProductHierarchyService: ProductHierarchyService,
            FilteredHierarchy:FilteredHierarchy,
            EntityManager: EntityManager,
            EntityTypeUtils: EntityTypeUtils,
            MDUsageService:MDUsageService,
            JobParamManager:JobParamManager
        },
        Loader: {
            LoaderStatus: LoaderStatus,
            Loader: Loader,

        },
        Hierarchy: {
            HierarchyService: HierarchyService,
            HierarchyProcessingStatus: HierarchyProcessingStatus,
            HierarchyStructureManager: HierarchyStructureManager,
            HierarchyStructureNavigator: HierarchyStructureNavigator
        },
        BusinessPolicy: {
            BusinessPolicyService: BusinessPolicyService,
            BusinessPolicyProcessingStatus: BusinessPolicyProcessingStatus
        },
        BusinessModeler: {

        },
        HyperRectangle: {
            CubeSourceMetaDataService: CubeSourceMetaDataService,
            CubeSourceUtils: CubeSourceUtils
        },
        Model: {
            ModelUtils: ModelUtils,
            ModelingSessionStatus: ModelingSessionStatus,
            ModelingSessionService: ModelingSessionService,
            ModelingScorecardService: ModelingScorecardService
        },
        Settlement: {
            SettlementMetricsService: SettlementMetricsService,
        },
        Concurrency:{
            PALockClient:PALockClient,
            PALockAdminClient:PALockAdminClient
        },
        UIFramework:{
            UIFrameworkService:UIFrameworkService,
            UIClipboardService:UIClipboardService,
        },
        Reporting:{
            DimensionDataService: DimensionDataService,
            PAReportTokenService: PAReportTokenService,
            PATagDataService:PATagDataService
        }
    },
}

export {MdlServices}